export default __webpack_public_path__ + "static/background-2-09d13d4fc614bd41ea909ed53740d9ca.png";